import { DialogController } from 'aurelia-dialog';
import { autoinject } from 'aurelia-framework';

@autoinject
export class AnalysisCompanyDialog {
  constructor(protected dialogController: DialogController) {}

  onCreated(analysisCompanyId: number) {
    this.dialogController.cancel({ analysisCompanyId });
  }
}
